import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import strings from './strings.json';
import md5 from 'md5';

function Payments({ lang }) {
  const [modal, setModal] = useState(false);
  const [addmodal, setAddModal] = useState(false);
  const [payId, setPayId] = useState("");
  const [custName, setcustName] = useState("");
  const [mobile, setMobile] = useState("");
  const [file_no, setFile_no] = useState("");
  const [status, setStatus] = useState(0);
  const [comment, setComment] = useState("");
  const [last, setLast] = useState("");
  const tableRef = useRef(null);

  const handleToggle = () => {
    setStatus(prev => (prev === 0 ? 1 : 0));
  };

  const openModal = (cId, cName, cMobile, cFile_no, cStatus, cComment) => {
    setPayId(cId);
    setcustName(cName);
    setMobile(cMobile);
    setFile_no(cFile_no);
    setStatus(cStatus);
    setComment(cComment);
    setModal(!modal);
    const modalDiv = document.querySelector(".booking-modal__car-info");
    modalDiv.scroll(0, 0);
  }

  let [filteredData,setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const closeModal = () => {
    setModal(!modal);
    setcustName("");
    setFile_no("");
    setStatus("");
    setMobile("");
    setComment("");
  }

  const addModal = () => {
    setAddModal(!addmodal);
    const modalDiv = document.querySelector(".booking-modal__car-info");
    modalDiv.scroll(0, 0);
  }

  const [data, setData] = useState([]);

  const fetchData = async(e) => {
    try {
      const response = await axios({
        method: "get",
        url: "https://api.hardrockrental.net/getPayments.php",
        headers: { "Content-Type": "multipart/form-data" },
      });
      setFilteredData(response.data);
      setData(response.data);
      setLast(response.data[response.data.length-1].id+1);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
      fetchData();
  }, []);

  var formData = new FormData();

  const updatePayments = async() => {
  formData.append('id', payId);
  formData.append('customer', custName);
  formData.append('file_no', file_no);
  formData.append('mobile', mobile);
  formData.append('status', status);
  formData.append('comment', comment);
  formData.append('signature2', sessionStorage.getItem("userdata"));
    try {
      await axios({
        method: "post",
        url: "https://api.hardrockrental.net/updatePayments.php",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      closeModal();
      fetchData();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  var bodyFormData = new FormData();
  bodyFormData.append('id', last);

  const addPayments = async() => {
  bodyFormData.append('customer', custName);
  bodyFormData.append('file_no', file_no);
  bodyFormData.append('mobile', mobile);
  bodyFormData.append('status', status);
  bodyFormData.append('comment', comment);
  bodyFormData.append('signature', sessionStorage.getItem("userdata"));
  bodyFormData.append('signature2', sessionStorage.getItem("userdata"));
    try {
      await axios({
        method: "post",
        url: "https://api.hardrockrental.net/addPayments.php",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      setAddModal(!addmodal);
      setcustName("");
      setFile_no("");
      setMobile("");
      setStatus("");
      setComment("");
      fetchData();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const [visibleRows, setVisibleRows] = useState(10);
  
    const handleLoadMore = () => {
      setVisibleRows((prevRows) => prevRows + 10);
    };
  
    const handleShowAll = () => {
      setVisibleRows(data.length);
    };
  
    const handleLoadLess = () => {
      setVisibleRows((prevRows) => prevRows - 10);
    };
  

  const searchSpace = (event) => {
    setSearch(event.target.value);
    if(event.target.value === "") {
      setFilteredData(data);
    } else {
      filteredData = data.filter((datas)=>{
        if((datas.custName).includes(search) || (datas.file_no).includes(search) || (datas.mobile).includes(search)){
          return datas
        } else {
          return false;
        }
      });
      setFilteredData(filteredData);
    }
  }
  
  return (
    <>
      <div className="team-container" id="content" style={{ paddingBottom: "0px" }}>
        <p>
        {strings[lang].Vehicles1} {sessionStorage.getItem("userdata").toUpperCase()}{" "}
          <i className="fa-regular fa-face-grin-beam"></i>
          <br></br> {strings[lang].Vehicles2} <b>{data.length} {strings[lang].Panel10}</b>
        </p>
        <input placeholder={strings[lang].Vehicles5} value={search} id="search" type="text" onChange={(e)=>searchSpace(e)}/>
        <button type="submit" style={{ borderRadius: "50px", boxShadow: "none"}} onClick={() => addModal()}>{strings[lang].Form59}</button><br></br>
      </div>
      <div className="book-content__box">
                <table
                ref={tableRef}
                style={{
                  alignSelf: "center",
                  textAlign: lang === "ar" ? "right" : "left",
                  fontSize: "15px",
                }}
              >
                <thead>
                <tr>
                  <th>#</th>
                  <th>{strings[lang].Form2}</th>
                  <th>{strings[lang].Form3}</th>
                  <th>{strings[lang].Taxi3}</th>
                  <th>{strings[lang].Form58}</th>
                  {sessionStorage.getItem("usertype") === md5("admin") && (
                  <>
                  <th>
                  <b>{strings[lang].Form39}</b>
                  </th>
                  <th>
                  <b>{strings[lang].Form61}</b>
                  </th>
                  </>
                  )}
                </tr></thead>
        {filteredData &&
          filteredData.slice(0, visibleRows).map(function (d, idx) {
            return (
              <tbody key={idx}>
                <tr key={idx}>
                  <td>{idx+1}.</td>
                  <td>{d.customer}</td>
                  <td>{d.mobile}</td>
                  <td>{d.file_no}</td>
                  <td>{d.status === 1 ? "Closed" : "Open"}</td>
                  {sessionStorage.getItem("usertype") === md5("admin") &&
                  <><td>{d.signature.toUpperCase()}</td>
                  <td>{d.signature2.toUpperCase()}</td></>}
                  <td style={{ padding: "2rem"}}><i className="fa-solid fa-pen-to-square" onClick={() => openModal(d.id, d.customer, d.mobile, d.file_no, d.status, d.comment)}></i></td>
                </tr>
              </tbody>
            );
          })}
          {visibleRows < data.length && sessionStorage.getItem("usertype") === md5("admin") ? (
                        <tfoot><tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                        <i className="fa-solid fa-circle-chevron-down fa-lg" onClick={handleLoadMore}></i>
                        <i className="fa-solid fa-border-all fa-lg" style={{ marginLeft: "1rem" }} onClick={handleShowAll}></i>
                        {visibleRows > 10 ?<i className="fa-solid fa-circle-chevron-up fa-lg" style={{ marginLeft: "1rem" }} onClick={handleLoadLess}></i> : ""}
                        </td></tr></tfoot>)
                        : visibleRows < data.length && sessionStorage.getItem("usertype") === md5("team") ? (
                        <tfoot><tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                        <i className="fa-solid fa-circle-chevron-down fa-lg" onClick={handleLoadMore}></i>
                        <i className="fa-solid fa-border-all fa-lg" style={{ marginLeft: "1rem" }} onClick={handleShowAll}></i>
                        {visibleRows > 10 ?<i className="fa-solid fa-circle-chevron-up fa-lg" style={{ marginLeft: "1rem" }} onClick={handleLoadLess}></i> : ""}
                        </td></tr></tfoot>
                        ) : ""}
            </table>
      </div>

      {/* modal ------------------------------------ */}

      <div className={`booking-modal ${modal ? "active-modal" : ""}`}>
        {/* title */}
        {/* car info */}
        <div className="booking-modal__car-info">
              <div className="team-container__box">
                <h2>
                {/* <img src={carslist.find((brand) => brand.name === custName).logo} onClick={() => closeModal()} style={{ width: '50px' }} /> */}
                  <i className="fa-solid fa-pen-to-square fa-2xl" onClick={() => closeModal()}></i>
                  </h2><br></br>
                <h3 style={{ textAlign: "left", marginTop: "1.5rem"}}>#{payId === "" ? "" : payId}</h3>
                <span><input type="text" placeholder="Customer Name" value={custName} onChange={(e) => setcustName(e.target.value)} />
                <input type="number" placeholder="Mobile No." value={mobile} style={{ marginLeft: '10px' }} onChange={(e) => setMobile(e.target.value)} /></span>
                <span><input type="text" placeholder="File No." value={file_no} onChange={(e) => setFile_no(e.target.value)} />
                <button type="text" style={{ marginLeft: '10px', borderRadius: '3px', padding: status === 1 ? '1.1rem 5.3rem' : '1.1rem 6rem', backgroundColor: status === 1 ? "black" : "red" }} onClick={handleToggle}>{status === 1 ? "Case closed" : "Case open"}</button></span>
                <input type="text" placeholder="Comment" value={comment} onChange={(e) => setComment(e.target.value)} />
                <button type="submit" onClick={() => updatePayments()}>
                {strings[lang].Vehicles38}
                </button> 
              </div>
        </div>
      </div>

      {/* modal ------------------------------------ */}

      <div className={`booking-modal ${addmodal ? "active-modal" : ""}`}>
        {/* title */}
        {/* car info */}
        <div className="booking-modal__car-info">
          <div className="team-container__box">
          <h2><i className="fa-solid fa-file-invoice-dollar fa-2xl" onClick={() => addModal()}></i></h2><br></br>
          <h3 style={{ textAlign: "left", marginTop: "1.5rem"}}>#{last}</h3>
          <span><input type="text" placeholder="Customer Name" value={custName} onChange={(e) => setcustName(e.target.value)} />
                <input type="number" placeholder="Mobile No." value={mobile} style={{ marginLeft: '10px' }} onChange={(e) => setMobile(e.target.value)} /></span>
                <span><input type="text" placeholder="File No." value={file_no} onChange={(e) => setFile_no(e.target.value)} />
                <button type="text" style={{ marginLeft: '10px', borderRadius: '3px', padding: status === 1 ? '1.1rem 5.3rem' : '1.1rem 6rem', backgroundColor: status === 1 ? "black" : "red" }} onClick={handleToggle}>{status === 1 ? "Case closed" : "Case open"}</button></span>
                <input type="text" placeholder="Comment" value={comment} onChange={(e) => setComment(e.target.value)} />
                <button type="submit" onClick={() => addPayments()}>
                {strings[lang].Vehicles37}
                </button> 
              </div>
        </div>
      </div>
    </>
  );
}

export default Payments;
